import * as z from "zod";

const inventorySource = z.object({
  locationName: z.string(),
  binName: z.string(),
  binType: z.string(),
  available: z.number(),
});

const workOrderSource = z.object({
  workOrderId: z.string(),
  status: z.string(),
  triggerKind: z.string(),
  quantity: z.number(),
});

const notStartedWorkOrder = z.object({
  workOrderId: z.string(),
  status: z.string(),
  triggerKind: z.string(),
  quantity: z.number(),
  isPriority: z.boolean(),
  // Input pickability from the work-order search index; null if not yet indexed.
  pickability: z
    .enum(["pickable", "partially_pickable", "not_pickable"])
    .nullable(),
});

const demandSource = z.object({
  fulfillmentGroupId: z.string(),
  orderName: z.string(),
  quantity: z.number(),
  status: z.string(),
  isPriority: z.boolean(),
});

const debugProductReplenishmentOutput = z.object({
  product: z.object({
    productId: z.string(),
    sku: z.string().nullable(),
    title: z.string(),
    accountId: z.string(),
    isBomOutput: z.boolean(),
  }),
  location: z.object({ id: z.string(), name: z.string() }).nullable(),
  supply: z.object({
    total: z.number(),
    availableInventory: z.number(),
    inFlightWorkOrders: z.number(),
    inventorySources: z.array(inventorySource),
    workOrderSources: z.array(workOrderSource),
  }),
  demand: z.object({
    total: z.number(),
    priorityTotal: z.number(),
    sources: z.array(demandSource),
  }),
  net: z.number(),
  // Not-started replenishment WOs the sync creates to fill net demand (not
  // counted in supply.total until they reach in_progress).
  notStartedWorkOrders: z.array(notStartedWorkOrder),
});

export type InventorySupplySource = z.infer<typeof inventorySource>;
export type WorkOrderSupplySource = z.infer<typeof workOrderSource>;
export type NotStartedWorkOrder = z.infer<typeof notStartedWorkOrder>;
export type DemandSource = z.infer<typeof demandSource>;
export type DebugProductReplenishmentResult = z.infer<
  typeof debugProductReplenishmentOutput
>;

export const debugProductReplenishment = {
  name: "debugProductReplenishment" as const,
  input: z.object({ productId: z.string() }),
  output: debugProductReplenishmentOutput,
  description:
    "Debug a product's replenishment supply and demand (and their sources) at the team's default fulfillment location",
};
